<template>
  <!-- <div class="loader-box"> -->
  <!-- v-show="loading" -->
  <!-- <div class="loader"></div> -->
  <!-- <div class="aaa">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

    <p class="loader-text">{{ text }}</p> -->

  <div class="spinner" v-show="loading">
    <div></div>
    <div></div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "view-loading",
  props: {
    text: String,
    loading: {
      default: true,
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.spinner {
  width: 60px;
  height: 60px;
  /* position: relative; */
  position: fixed;
  top: 41%;
  left: 50%;
  margin: 100px auto;
}
.spinner div {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #668aeb;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  animation: may 1s infinite ease-in-out;
}
@keyframes may {
  0% {
    transform: scale(0);
    opacity: 0.6;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
/* ////////////////////////////// */
.loader-box {
  width: 200px;
  height: 200px;
  border: 1px solid currentcolor;
  border-radius: 3px;
  font-size: 30px;
  padding: 1em;
  position: fixed;
  margin-bottom: 0.25em;
  vertical-align: top;
  transition: 0.3s color, 0.3s border, 0.3s transform, 0.3s opacity;
  top: 50%;
  left: 50%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}

.loader {
  border: 15px dotted #fff;
  height: 140px;
  /* background: rgb(172, 36, 36); */
  border-radius: 50%;
  animation: 2.5s loader linear infinite;
}

.loader-text {
  position: absolute;
  width: 150px;
  height: 150px;
  line-height: 150px;
  top: 50%;
  left: 50%;
  margin-top: -75px;
  margin-left: -75px;
  text-align: center;
  font-size: 20px;
  color: #fff;
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.aaa {
  width: 140px;
  height: 140px;
  position: relative;
  margin: 0 auto;
  border-radius: 50%;
}
.aaa span {
  width: 12px;
  height: 12px;
  background-color: #fff;
  position: absolute;
  border-radius: 50%;
  -webkit-animation: load 1.04s ease infinite;
  animation: load 1.04s ease infinite;
}
@-webkit-keyframes load {
  0% {
    -webkit-transform: scale(1.2);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(0.3);
    opacity: 0.5;
  }
}
@keyframes load {
  0% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(0.3);
    transform: scale(0.3);
    opacity: 0.5;
  }
}
.aaa span:nth-child(1) {
  left: 0;
  top: 50%;
  margin-top: -4px;
  -webkit-animation-delay: 0.13s;
  animation-delay: 0.13s;
}
.aaa span:nth-child(2) {
  left: 20px;
  top: 20px;
  -webkit-animation-delay: 0.26s;
  animation-delay: 0.26s;
}
.aaa span:nth-child(3) {
  left: 50%;
  top: 0;
  margin-left: -4px;
  -webkit-animation-delay: 0.39s;
  animation-delay: 0.39s;
}

.aaa span:nth-child(4) {
  right: 20px;
  top: 20px;
  -webkit-animation-delay: 0.52s;
  animation-delay: 0.52s;
}
.aaa span:nth-child(5) {
  right: 0;
  top: 50%;
  margin-top: -4px;
  -webkit-animation-delay: 0.65s;
  animation-delay: 0.65s;
}
.aaa span:nth-child(6) {
  right: 20px;
  bottom: 20px;
  -webkit-animation-delay: 0.78s;
  animation-delay: 0.78s;
}
.aaa span:nth-child(7) {
  left: 50%;
  bottom: 0;
  margin-left: -4px;
  -webkit-animation-delay: 0.91s;
  animation-delay: 0.91s;
}
.aaa span:nth-child(8) {
  left: 20px;
  bottom: 20px;
  -webkit-animation-delay: 1.04s;
  animation-delay: 1.04s;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/view-loading/view-loading.vue